import { Sponsors } from "../test/dataset";
import { Link } from "react-router-dom";

export default function SponsersAffiliations({hidePadding = false}) {
    return (<div className={`container mx-auto mt-[90px] mb-[120px] max-md:mb-[80px] max-md:mt-[60px]  ${hidePadding ? '' : 'px-6'}`}>
        <div className="flex items-center justify-between max-md:flex-col max-md:justify-start max-md:items-start">
          <div className="flex flex-col">
            <div className="font-medium leading-tight text-26 text-secondary max-md:text-18">
              Our Sponsors & Affiliations
            </div>
            <div className="text-14 text-light-gray/60 max-md:text-12 max-md:font-text">
              We proudly partner with leading organizations to drive innovation and excellence in our industry
            </div>
          </div>
        </div>

        {/* Sponsors Grid - 3x3 layout with fixed dimensions */}
        <div className="grid grid-cols-1 gap-4 mt-6 md:grid-cols-2 lg:grid-cols-3">
          {Sponsors.map((sponsor, i) => (
            <Link
              key={i}
              to={`${sponsor.link}${sponsor.link.includes('?') ? '&' : '?'}utm_source=pharmacywiki&utm_medium=sponsor&utm_campaign=sponsor_affiliation`}
              target="_blank"
              className="group"
            >
              <div className="flex h-full overflow-hidden transition-all duration-300 bg-white border rounded-xl border-white/10 hover:shadow-lg hover:shadow-primary/5 hover:border-primary/20">
                <div className="flex items-center justify-center flex-shrink-0 p-4 bg-gradient-to-r from-gray-50 to-gray-100" style={{ width: '100px' }}>
                  <img
                    src={sponsor.image}
                    alt={sponsor.name}
                    className="object-contain w-full h-16"
                    onError={(e) => {
                      e.target.src = "https://imageplaceholder.net/100x80/f3f4f6/131313?text=Sponsor";
                    }}
                  />
                </div>
                <div className="flex flex-col flex-1 p-4">
                  <div className="font-medium truncate transition-colors text-16 text-secondary group-hover:text-primary">
                    {sponsor.name}
                  </div>
                  <div className="mt-1 text-12 font-text text-light-gray/60 line-clamp-3 h-[54px]">
                    {sponsor.description}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    )
}